module.exports = __webpack_public_path__ + "img/vol05_character_thumb01.39fecb67.png";